import { render } from "./ElementStyles.vue?vue&type=template&id=37b96ca0&scoped=true"
import script from "./ElementStyles.vue?vue&type=script&lang=js"
export * from "./ElementStyles.vue?vue&type=script&lang=js"

import "./ElementStyles.vue?vue&type=style&index=0&id=37b96ca0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-37b96ca0"

export default script